import { InjectionToken } from '@angular/core';

import { FacetsStoreAssets } from '../facets.store';

export const FacetsStoreAssetsInjectionToken = new InjectionToken<FacetsStoreAssets>('FacetsStoreAssets');
export const FacetsEndpointInjectionToken = new InjectionToken<string>('FacetsEndpoint');
